import { render, staticRenderFns } from "./Long.vue?vue&type=template&id=0398dad4&"
import script from "./Long.vue?vue&type=script&lang=js&"
export * from "./Long.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports